/* eslint-disable func-names */
import tmsIndentAxiosInstance from '@/tms-indent-axios';
import tmsMdmAxiosInstance from '@/tms-mdm-axios';

export const getConsignees = async function (params) {
  try {
    return await tmsIndentAxiosInstance.get('order/search_consignees', { params });
  } catch (error) {
    throw error;
  }
};
export const getContracts = async function (data) {
  try {
    return await tmsIndentAxiosInstance.put('/order/v1/routes', { data });
  } catch (error) {
    throw error;
  }
};
export const searchDepots = async function (params) {
  try {
    return await tmsIndentAxiosInstance.get('order/search_depot_gates', { params });
  } catch (error) {
    throw error;
  }
};
export const createIndent = async function (data, allTransportersSelected = false) {
  try {
    return await tmsIndentAxiosInstance.post(`/order/v1/?is_all_selected=${allTransportersSelected}`, { data });
  } catch (error) {
    throw error;
  }
};
export const updateIndent = async function (id, data, isOptimaIndent=false) {
  try {
    return await tmsIndentAxiosInstance.put(`/order/v1/${id}/?is_optima_indent=${isOptimaIndent}`, { data });
  } catch (error) {
    throw error;
  }
};
export const checkVehicleCongestion = async function (data) {
  try {
    return await tmsIndentAxiosInstance.post('/order/check_vehicle_congestion', { data });
  } catch (error) {
    throw error;
  }
};
export const createFromDraft = async function (id, data, allTransportersSelected = false) {
  try {
    return await tmsIndentAxiosInstance.post(`/order/create_from_draft/${id}?is_all_selected=${allTransportersSelected}`, { data });
  } catch (error) {
    throw error;
  }
};
export const getIndentBootstrap = async function () {
  try {
    return await tmsIndentAxiosInstance.get('/bootstrap/indent');
  } catch (error) {
    throw error;
  }
};

export const getPurchaseOrderFieldsList = async function (params) {
  try {
    return await tmsMdmAxiosInstance.get('/purchase_order/indent_filter', { params });
  } catch (error) {
    throw error;
  }
};
export const updateHachIndent = async function (id, data) {
  try {
    return await tmsMdmAxiosInstance.post(`/packing/update_indent/${id}`, { data });
  } catch (error) {
    throw error;
  }
};
export const getConsigneeSingleData = async function (consigneeId) {
  try {
    return await tmsMdmAxiosInstance.get(`/consignee/${consigneeId}`);
  } catch (error) {
    throw error;
  }
};
export const updateConsigneeSingleData = async function ({ payload, consigneeId }) {
  try {
    return await tmsMdmAxiosInstance.put(`/consignee/${consigneeId}`, { data: payload });
  } catch (error) {
    throw error;
  }
};
